var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10209 6.86219C6.34527 7.09192 6.66698 7.22012 7.00151 7.22061C7.33604 7.2211 7.65813 7.09383 7.90197 6.86481L12.3098 2.72431C12.1521 2.65884 11.9831 2.62509 11.8123 2.625H2.18734C2.02554 2.62592 1.86531 2.65693 1.71484 2.71644L6.10209 6.86219Z",
    fill: "#04BA96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50106 7.50269C8.09431 7.88374 7.55759 8.09542 7.00023 8.09461C6.44286 8.0938 5.90677 7.88055 5.50113 7.49831L1.05 3.29306C0.93656 3.48898 0.876237 3.71111 0.875 3.9375V10.0625C0.875 10.4106 1.01328 10.7444 1.25942 10.9906C1.50556 11.2367 1.8394 11.375 2.1875 11.375H11.8125C12.1606 11.375 12.4944 11.2367 12.7406 10.9906C12.9867 10.7444 13.125 10.4106 13.125 10.0625V3.9375C13.1235 3.71909 13.0668 3.50462 12.9601 3.31406L8.50106 7.50269Z",
    fill: "#7A7B93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letterIcon.cd744f9aae59488c08e8fc5e78d49f9e.svg";
export { ForwardRef as ReactComponent };